module.exports = {
  ROOT       : 0,
  GROUP      : 1,
  POSITION   : 2,
  SET        : 3,
  RANGE      : 4,
  REPETITION : 5,
  REFERENCE  : 6,
  CHAR       : 7,
};



//////////////////
// WEBPACK FOOTER
// ./~/ret/lib/types.js
// module id = 269
// module chunks = 0